<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data User" subTitle="Forms" />

    <CreateUser />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateUser from "@/components/Pages/Master/User/CreateUser.vue";

export default defineComponent({
  name: "CreateUserPage",
  components: {
    PageTitle,
    CreateUser,
  },
});
</script>
